// 'use client';

// import { useEffect } from 'react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// function ConfigAos({ children }) {
//   useEffect(() => {
//     // Initialize AOS
//     AOS.init();
//     // AOS.init({
//     //   duration: 300,
//     //   easing: 'linear',
//     //   once: true, // Only animate once on page load
//     // });

//     // Refresh AOS on window resize or other triggers if needed
//     const handleResize = () => {
//       AOS.refresh();
//     };

//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   return <>{children}</>;
// }

// export default ConfigAos;
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ConfigAos = ({ children }) => {
  useEffect(() => {
    AOS.init({
      duration: 400,
      once: false,
      easing: 'ease-out',
    });

    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);

  return <>{children}</>;
};

export default ConfigAos;
